import MobileNumber from "../../components/MobileNumber";
import { order } from "../SmartSearchParammeter";

export default async function MobileNumberConfig(key) {
  return {
    description: "Mobile number",
    id: "mobileNumber",
    initial: undefined,
    type: order.third,
    handleValues: (searchObject) => {
      return;
    },

    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <MobileNumber searchObject={searchObject} onChange={onChange} t={t} />
      </div>
    ),
    operation: ["Exact", "Like"],
    list: [],

    handler: function (searchObj, value) {
      searchObj["mobileNumber"] = value[0];
    }
  };
}